<template>
    <client-page>
        <sub-visual subTab sh="Project / Reference" index="01" total="02" tabActive="Project" bg="/images/sub/visual/sv3.jpg"> </sub-visual>

        <section class="section section--first section--last">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">Project</h2>
                </div>

                <div class="pb-10 pb-md-20">
                    <v-select v-model="filter.searchKey" :items="searchItems" outlined hide-details class="w-100 mw-sm-280px ml-auto" @input="search" />
                </div>
                <v-data-table :headers="headers" :items="items" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer mobile-breakpoint="0" @page-count="pageCount = $event" class="v-data-table--default v-data-table--no-active"></v-data-table>

                <div class="v-pagination-wrap text-center">
                    <v-pagination v-model="page" :length="pageCount" total-visible="5"></v-pagination>
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import projectData from "@/assets/data/projects.json";
export default {
    components: {
        ClientPage,
        SubVisual,
    },
    data() {
        return {
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,

            filter: {
                searchKey: null,
            },

            headers: [
                { text: "P/J 이름", value: "name", sortable: false, align: "center", width: "27%" },
                { text: "고객", value: "client", sortable: false, align: "center", width: "12%" },
                { text: "최종사용자", value: "user", sortable: false, align: "center", width: "24%" },
                { text: "연도", value: "year", sortable: false, align: "center", width: "10%" },
                { text: "서술", value: "description", sortable: false, align: "center", width: "27%" },
            ],
            items: [],
            originalItems: projectData,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },
        search() {
            this.page = 1;
            if (!this.filter.searchKey) {
                this.items = this.originalItems;
            } else {
                this.items = this.originalItems.filter((el) => this.filter.searchKey === el.year);
            }
        },
    },
    computed: {
        searchItems() {
            let result = [{ text: ":: ALL ::", value: null }];

            let year = [];
            for (let i = 0; i < this.originalItems.length; i++) {
                if (year.indexOf(this.originalItems[i].year) === -1) {
                    year.push(this.originalItems[i].year);
                    result.push({ text: this.originalItems[i].year, value: this.originalItems[i].year });
                }
            }

            return result;
        },
    },
};
</script>

<style lang="scss" scoped></style>
